import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard,
  Store,
  Wallet,
  MessageCircle,
  Settings,
  ShoppingCart,
  Package,
  Home,
  CreditCard,
} from 'lucide-react';

const adminNav = [
  { to: '/admin', icon: LayoutDashboard, label: 'Genel Bakış', end: true },
  { to: '/admin/dealers', icon: Store, label: 'Bayiler' },
  { to: '/admin/orders', icon: ShoppingCart, label: 'Siparişler' },
  { to: '/admin/payment-tracking', icon: Wallet, label: 'Ödeme Takibi' },
  { to: '/admin/whatsapp', icon: MessageCircle, label: 'WhatsApp' },
];

const dealerNav = [
  { to: '/dealer', icon: Home, label: 'Ana Sayfa', end: true },
  { to: '/dealer/shop', icon: ShoppingCart, label: 'Mağaza' },
  { to: '/dealer/orders', icon: Package, label: 'Siparişler' },
  { to: '/dealer/payments', icon: CreditCard, label: 'Ödemeler' },
];

export const BottomNav = () => {
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'super_admin' || user?.role === 'personnel';
  const items = isAdmin ? adminNav : dealerNav;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#1a224f] lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="bottom-nav"
    >
      <div className="flex h-14 items-center justify-around px-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={`bnav-${item.to.replace(/\//g, '-').replace(/^-/, '')}`}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-0.5 py-1 text-[10px] font-medium transition-colors',
                isActive ? 'text-white' : 'text-white/50'
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className={cn(
                  'flex h-7 w-7 items-center justify-center rounded-lg transition-all duration-200',
                  isActive && 'bg-white/20 scale-110'
                )}>
                  <item.icon className={cn('h-4.5 w-4.5', isActive && 'stroke-[2.5]')} />
                </div>
                <span className="leading-none whitespace-nowrap">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
